function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import React from 'react';
import MultiFilter from './MultiFilter';
import SingleSelect from './SingleSelect';
import MultiToggle from './MultiToggle';
import SingleToggle from './SingleToggle';
import DateFilter from './DateFilter';
import { FacetWidgetType } from './DynamicListingComponent';
import { ReactComponent as IconArrowLeft } from '../../resources/icons/IconArrowLeft.svg';
import { tealiumMergeClickData, tealiumClickFunc } from '../../utils/tealium';
import { mobileCheck } from "../../utils";
class FilterBlock extends React.Component {
  constructor() {
    super(...arguments);
    this.state = {
      filterOpen: false,
      facetsWidgetsOpenStatus: {},
      filtersCount: 0,
      filtersValue: {}
    };
    this.getFiltersCount = () => {
      const {
        filters
      } = this.props;
      if (filters || Object.keys(filters).length !== 0) {
        let count = 0;
        for (let key in filters) {
          let isEmty = filters[key].length === 1 && filters[key].includes('');
          if (filters[key].length !== 0 && !isEmty) {
            count = count + 1;
          }
        }
        this.setState({
          filtersCount: count
        });
      }
    };
    // Close all filters popups and selectboxes.
    this.initializeDropdownState = e => {
      e && e.preventDefault();
      const newFacetsStatus = {};
      // eslint-disable-next-line array-callback-return
      this.props.facetsSchema.map(_ref => {
        let {
          facetName
        } = _ref;
        return facetName.value;
      }).map(facetName => {
        newFacetsStatus[facetName] = false;
      });
      this.setState({
        facetsWidgetsOpenStatus: newFacetsStatus
      });
    };
    // Open/close particular filter's popup/selectbox.
    this.setFilterDropdownState = (state, key) => {
      const results = this.props.facetsSchema.map(_ref2 => {
        let {
          facetName
        } = _ref2;
        return facetName.value;
      }).reduce((acc, itemKey) => {
        acc[itemKey] = itemKey === key ? state : false;
        return acc;
      }, {});
      this.setState({
        facetsWidgetsOpenStatus: results
      });
    };
    // Submit new filters, trigger research and close Filters block.
    this.setFilterMultipleChoicesState = (filters, filterName, isOpened) => {
      this.props.setFilters(_objectSpread(_objectSpread({}, this.props.filters), {}, {
        [filterName]: filters
      }));
      if (mobileCheck() && !isOpened) {
        this.setState({
          filterOpen: false
        });
      }
    };
    // Submit new filters, trigger research and close Filters block.
    this.setFilterChoiceState = (checked, key, filterName, isSingleSelect) => {
      const result = _objectSpread({}, this.props.filters);
      result[filterName] = isSingleSelect ? [key] : FilterBlock.toggleItem(result[filterName], key, checked);
      this.props.setFilters(result);
      if (mobileCheck()) {
        this.setState({
          filterOpen: false
        });
      }
    };
    // Reset all checkboxes in single filter.
    this.resetFilterChoiceState = filterName => {
      const result = _objectSpread({}, this.props.filters);
      result[filterName] = [];
      this.props.setFilters(result);
      this.getFiltersCount();
    };
    // Reset all filters back to empty.
    this.resetFilters = e => {
      this.props.setFilters({});
      this.getFiltersCount();
      e.preventDefault();
    };
    // Open/close Filters panel.
    this.toggleFilter = e => {
      if (mobileCheck()) {
        this.setState(prevState => {
          if (prevState.filterOpen) {
            document.body.classList.remove('filter__wrapper--open');
          } else {
            document.body.classList.add('filter__wrapper--open');
          }
          return {
            filterOpen: !prevState.filterOpen
          };
        });
      }
      e.preventDefault();
    };
    this.submitAll = e => {
      this.getFiltersCount();
      this.toggleFilter(e);
    };
  }
  componentDidMount() {
    this.initializeDropdownState();
    this.getFiltersCount();
    if (!mobileCheck()) {
      this.setState({
        filterOpen: true
      });
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.filters !== this.props.filters) {
      this.getFiltersCount();
    }
  }
  componentWillUpdate(nextProps) {
    if (nextProps.facets !== this.props.facets || nextProps.facetsSchema !== this.props.facetsSchema || nextProps.resultsAmount !== this.props.resultsAmount) {
      !mobileCheck() && this.initializeDropdownState();
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    return nextState !== this.state || nextProps.facets !== this.props.facets || nextProps.facetsSchema !== this.props.facetsSchema || nextProps.resultsAmount !== this.props.resultsAmount;
  }
  render() {
    const isFilterSubmenuOpen = Object.values(this.state.facetsWidgetsOpenStatus).find(isOpen => isOpen);
    const filtersPerRows = [];
    let row = 0;
    const {
      filtersClickAnalytics,
      fitlersCategoryAnalytics,
      fitlersClearAnalytics,
      fitlersValueAnalytics,
      filtersShowResultsAnalytics,
      params
    } = this.props;
    // eslint-disable-next-line array-callback-return
    this.props.facetsSchema.map(facet => {
      // This mapping is required to render all widget types 3 per row, except Toggle ones,
      // they need whole separate row.
      const isOnePerLine = facet.widgetType.value === FacetWidgetType.MULTI_TOGGLE || facet.widgetType.value === FacetWidgetType.SINGLE_TOGGLE;
      filtersPerRows[row] = filtersPerRows[row] || [];
      if (isOnePerLine) {
        if (filtersPerRows[row].length !== 0) {
          filtersPerRows[++row] = [];
        }
        filtersPerRows[row].push(facet);
        row++;
      } else {
        filtersPerRows[row].push(facet);
        if (filtersPerRows[row].length === 3) {
          row++;
        }
      }
    });
    const headerDirection = this.props.rtl ? {
      flexDirection: 'row-reverse'
    } : {};
    const filterScrollDirection = this.props.rtl ? {
      marginRight: '-30px'
    } : {
      marginLeft: '-30px'
    };
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: `filter__wrapper ${this.state.filterOpen ? 'filter__wrapper--open' : ''} ${isFilterSubmenuOpen ? 'filter__wrapper--submenu-open' : ''}`
    }, /*#__PURE__*/React.createElement("div", {
      className: `row ${mobileCheck() ? '' : 'hide-menu-trigger-button'}`
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-md-4"
    }), /*#__PURE__*/React.createElement("div", {
      className: "col-12 col-md-4"
    }, /*#__PURE__*/React.createElement("button", {
      className: "btn btn-secondary js-filters-trigger filter__toggle",
      onClick: e => {
        tealiumClickFunc(tealiumMergeClickData(filtersClickAnalytics, params));
        this.toggleFilter(e);
      }
    }, this.props.filtersButtonLabel, this.state.filtersCount > 0 && ` (${this.state.filtersCount})`)), /*#__PURE__*/React.createElement("div", {
      className: "col-md-4"
    })), /*#__PURE__*/React.createElement("div", {
      className: "filter"
    }, /*#__PURE__*/React.createElement("div", {
      className: "filter__header"
    }, /*#__PURE__*/React.createElement("div", {
      className: "row",
      style: headerDirection
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-auto"
    }, /*#__PURE__*/React.createElement("a", {
      className: "body-medium filter__header-back-link js-btn-close-panel back-icon-color",
      href: "/#",
      onClick: this.initializeDropdownState,
      "aria-label": "Close field"
    }, /*#__PURE__*/React.createElement(IconArrowLeft, null)), /*#__PURE__*/React.createElement("a", {
      className: "body-medium filter__header-links js-filters-close back-icon-color",
      href: "/#",
      onClick: this.toggleFilter,
      "aria-label": "Close filter"
    }, /*#__PURE__*/React.createElement(IconArrowLeft, null))), /*#__PURE__*/React.createElement("div", {
      className: "col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "filter__header-text body-medium"
    }, /*#__PURE__*/React.createElement("span", null, this.props.filtersButtonLabel), /*#__PURE__*/React.createElement("span", {
      className: "js-opened-filter-label submenu__text"
    }, " "))), /*#__PURE__*/React.createElement("div", {
      className: "col-auto"
    }, /*#__PURE__*/React.createElement("a", {
      className: "body-medium filter__header-links",
      href: "/#",
      onClick: this.resetFilters,
      "aria-label": "Clear all",
      "aria-labelledby": "Clear all"
    }, this.props.clearAllButtonLabel)))), /*#__PURE__*/React.createElement("div", {
      className: "filter__scroll",
      style: filterScrollDirection
    }, filtersPerRows.map((row, index) => /*#__PURE__*/React.createElement("div", {
      className: "filter__row",
      key: `filter-row-${index}`
    }, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-md col-lg-9 offset-lg-1"
    }, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, row.map(facetDefinition => {
      let Component;
      switch (facetDefinition.widgetType.value) {
        case FacetWidgetType.MULTI_TOGGLE:
          Component = MultiToggle;
          break;
        case FacetWidgetType.SINGLE_TOGGLE:
          Component = SingleToggle;
          break;
        case FacetWidgetType.SINGLE_SELECT:
          Component = SingleSelect;
          break;
        case FacetWidgetType.MULTI_SELECT:
        default:
          Component = MultiFilter;
      }
      if (facetDefinition.facetName.value === 'monthyear') {
        Component = DateFilter;
      }
      return /*#__PURE__*/React.createElement(Component, {
        key: facetDefinition.facetName.value,
        label: facetDefinition.facetLabel.value,
        filterName: facetDefinition.facetName.value,
        setFilterDropdownState: this.setFilterDropdownState,
        items: this.props.facets[facetDefinition.facetName.value] || {},
        isOpen: Boolean(this.state.facetsWidgetsOpenStatus[facetDefinition.facetName.value]),
        resultsAmount: this.props.resultsAmount,
        setFilterChoiceState: this.setFilterChoiceState,
        setFilterMultipleChoicesState: this.setFilterMultipleChoicesState,
        filters: this.props.filters[facetDefinition.facetName.value] || [],
        resetFilterChoiceState: this.resetFilterChoiceState,
        clearAllLabel: this.props.clearAllButtonLabel,
        showNResultsLabel: this.props.showNResultsLabel,
        filtersClickAnalytics: filtersClickAnalytics,
        fitlersCategoryAnalytics: fitlersCategoryAnalytics,
        fitlersClearAnalytics: fitlersClearAnalytics,
        fitlersValueAnalytics: fitlersValueAnalytics,
        filtersShowResultsAnalytics: filtersShowResultsAnalytics,
        params: params
      });
    }))), index === 0 && /*#__PURE__*/React.createElement("div", {
      className: "col-md-auto col-lg-2 d-flex justify-content-end align-items-end filter__col-clear"
    }, /*#__PURE__*/React.createElement("a", {
      className: "body-medium link-clear filter-panel__row-clear",
      href: "/#",
      "aria-label": "Clear fitlers",
      onClick: e => {
        tealiumClickFunc(tealiumMergeClickData(fitlersClearAnalytics, params));
        this.resetFilters(e);
      }
    }, this.props.clearAllButtonLabel)))))), /*#__PURE__*/React.createElement("div", {
      className: "filter__btn-row"
    }, /*#__PURE__*/React.createElement("button", {
      className: "btn btn-primary js-filters-close",
      onClick: this.submitAll
    }, this.props.showNResultsLabel.replace('{#resultsAmount#}', ''))))));
  }
}
FilterBlock.defaultProps = {
  filtersButtonLabel: 'Filters',
  clearButtonLabel: 'Clear',
  clearAllButtonLabel: 'Clear All',
  cancelButtonLabel: 'Cancel',
  showNResultsLabel: 'Show {#resultsAmount#} results CUSTOM'
};
// Check/uncheck particular value inside multiselect filter.
FilterBlock.toggleItem = function () {
  let array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let value = arguments.length > 1 ? arguments[1] : undefined;
  let add = arguments.length > 2 ? arguments[2] : undefined;
  const items = [...array];
  const index = items.findIndex(item => item === value);
  index > -1 && !add ? items.splice(index, 1) : add && items.push(value);
  return items;
};
export default FilterBlock;